import { CLIENT_TYPE, Condition } from './constants';

export const getPrefixIdForConfiguration = ({
  dealerId,
  clientType,
  condition,
}: {
  dealerId: string;
  clientType: CLIENT_TYPE;
  condition: Condition;
}) => {
  return `dealerId:${dealerId?.toLowerCase()}.type:${clientType?.toLowerCase()}.condition:${condition?.toLowerCase()}`;
};

export const getConfigurationId = ({
  dealerId,
  clientType,
  condition,
  modelYearRangeId,
}: {
  dealerId: string;
  clientType: CLIENT_TYPE;
  condition: Condition;
  modelYearRangeId?: string;
}) => {
  const configurationId = getPrefixIdForConfiguration({
    dealerId,
    clientType,
    condition,
  });

  if (modelYearRangeId) {
    return configurationId.concat(`.${modelYearRangeId.toLowerCase()}`);
  }

  return configurationId;
};
